module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_9016.6239b89c.png";